import {useState} from 'react';
import {ChatState} from "../Context/ChatProvider";
import SideDrawer from "../components/miscellaneous/SideDrawer";
import MyChats from "../components/MyChats";
import ChatBox from "../components/ChatBox";
import InstallPWAPrompt from "./../components/miscellaneous/InstallPWAPrompt";
import InfoModal from '../components/Modals/InfoModal';

const ChatPage = () => {
    const [fetchAgain, setFetchAgain] = useState(false);
    const {user, installApp, infoIsOpen} = ChatState();

    return (
        <div className='chats_page'>
            {user && <SideDrawer />}
            {installApp &&  <InstallPWAPrompt />}
            {infoIsOpen &&  <InfoModal /> }
            <div className='chats_page_myChats-singleChat' >
                {user &&  <MyChats fetchAgain={fetchAgain} />}
                {user && <ChatBox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} /> }
            </div>
        </div>
    )
}

export default ChatPage
